module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-vertical-attr"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._t("default", function() {
    return [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63ecde07"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/business/common/rtVerticalAttr.vue
// module id = 1523
// module chunks = 124